import {
  SET_VALID_FIELD,
  REMOVE_VALID_FIELD,
  SET_INVALID_FIELD,
  REMOVE_INVALID_FIELD,
  REMOVE_FIELDS_CORRECTNESS,
} from "features/application/field/redux/types";

const fieldReducer = (
  state = { validFields: [], invalidFields: [] },
  action
) => {
  switch (action.type) {
    case SET_VALID_FIELD: {
      const { validFields } = state;

      !validFields.includes(action.payload) && validFields.push(action.payload);

      return { ...state, validFields };
    }
    case REMOVE_VALID_FIELD:
      return {
        ...state,
        validFields: state.validFields.filter(
          (name) => name !== action.payload
        ),
      };
    case SET_INVALID_FIELD: {
      const { invalidFields } = state;

      !invalidFields.includes(action.payload) &&
        invalidFields.push(action.payload);

      return { ...state, invalidFields };
    }
    case REMOVE_INVALID_FIELD:
      return {
        ...state,
        invalidFields: state.invalidFields.filter(
          (name) => name !== action.payload
        ),
      };
    case REMOVE_FIELDS_CORRECTNESS:
      return { validFields: [], invalidFields: [] };
    default:
      return state;
  }
};

export default fieldReducer;
